import React, { Component, FunctionComponent } from 'react'
import { Field, reduxForm } from 'redux-form'
import classnames from 'classnames'

import Loader from './loader'
import { ReduxFormProps } from '../forms'

export type Callback<T = void> = (...args: any) => T

export const validateFields = (values) => {
  const errors: { subject?: string; description?: string } = {}
  if (!values.subject) {
    errors.subject = 'Subject field must be completed'
  }

  if (!values.description) {
    errors.description = 'Description field must be completed'
  }

  return errors
}

export interface Input {
  name: string
}

export interface Meta {
  touched: boolean
  error: string
}

export interface CreateTicketTextAreaFieldProps {
  input: Input
  label: string
  type: string
  placeholder: string
  meta: Meta
}

// eslint-disable-next-line
export const createTicketTextAreaField: FunctionComponent<
  CreateTicketTextAreaFieldProps
> = ({
  input,
  label,
  // type, TODO-TS
  placeholder,
  meta: { touched, error },
}) => (
  <div className="form__section">
    <label htmlFor={input.name} className="form__label">
      {label}
    </label>
    {touched && error && (
      <label htmlFor={input.name} className="form__label form__label--error">
        {error}
      </label>
    )}
    <textarea
      {...input}
      // type={type} TODO-TS
      id={input.name}
      placeholder={placeholder}
      className={classnames(
        'form__input',
        'form__input--textarea',
        'form__input--full-width',
        {
          'form__input--error': touched && error,
        }
      )}
    />
  </div>
)

export const createTicketField = ({
  input,
  label,
  type,
  placeholder,
  meta: { touched, error },
}) => (
  <div className="form__section">
    <label htmlFor={input.name} className="form__label">
      {label}
    </label>
    {touched && error && (
      <label htmlFor={input.name} className="form__label form__label--error">
        {error}
      </label>
    )}
    <input
      {...input}
      type={type}
      id={input.name}
      placeholder={placeholder}
      className={classnames('form__input', 'form__input--full-width', {
        'form__input--error': touched && error,
      })}
    />
  </div>
)

export interface Props {
  hideModal?: Callback
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface FormProps {}

// eslint-disable-next-line
class CreateTicketForm extends Component<ReduxFormProps<Props, FormProps>> {
  static displayName = 'CreateTicketForm'

  render() {
    const { handleSubmit, pristine, submitting, hideModal } = this.props

    return (
      <form onSubmit={handleSubmit} className="form form--align-center">
        <Field
          type="text"
          label="Subject"
          name="subject"
          placeholder="What is the subject of this ticket?"
          component={createTicketField}
        />
        <Field
          type="description"
          label="Description"
          name="description"
          id="description"
          placeholder="Write a description of the issue"
          component={createTicketTextAreaField}
        />
        <button
          className="button button--secondary button--inline"
          type="button"
          onClick={hideModal}
        >
          Cancel
        </button>
        <button
          className="button button--primary"
          type="submit"
          disabled={pristine || submitting}
        >
          CreateTicket
          <Loader isLoading={submitting} className="loader--button" />
        </button>
      </form>
    )
  }
}

export default reduxForm<FormProps, Props>({
  form: 'createTicketForm',
  validate: validateFields,
})(CreateTicketForm)
